import * as path from "path";
import { SpawnSyncOptions } from "child_process";
export type PackageManagerType = "yarn" | "npm";

export type RunOptions = Omit<SpawnSyncOptions, "encoding"> & {
  envAdditions?: Record<string, string | undefined>;
  require?: boolean;
};
/**
 * Render the running of the given command as coming from the local bin.
 */
export function renderRunBin(
  pmt: PackageManagerType,
  commandString: string
): string {
  return pmt === "npm" ? `npx ${commandString}` : `yarn -s ${commandString}`;
}

/**
 * Render running of the given script defined in package.json.
 */
export function renderRunScript(
  pmt: PackageManagerType,
  scriptName: string
): string {
  return pmt === "npm" ? `npm run -s ${scriptName}` : `yarn -s ${scriptName}`;
}

// /**
//  * Run a command from the local project bin.
//  */
// export function runBin(
//   pmt: PackageManagerType,
//   commandString: string,
//   options?: proc.RunOptions
// ): ReturnType<typeof proc.run> {
//   const packageManagerRunCommand = renderRunBin(pmt, commandString);
//   return proc.run(packageManagerRunCommand, options);
// }

// /**
//  * Run a script defined in the local project package.json.
//  */
// export function runScript(
//   pmt: PackageManagerType,
//   scriptName: string,
//   options?: proc.RunOptions
// ): ReturnType<typeof proc.run> {
//   const packageManagerRunScript = renderRunScript(pmt, scriptName);
//   return proc.run(packageManagerRunScript, options);
// }

// /**
//  * Run package installation.
//  */
// export function installDeps(
//   pmt: PackageManagerType,
//   options?: proc.RunOptions
// ): ReturnType<typeof proc.run> {
//   return pmt === "npm"
//     ? proc.run("npm install", options)
//     : proc.run("yarn install", options);
// }

// export type AddDepsOptions = { dev?: boolean } & proc.RunOptions;

// /**
//  * Add a package to the project.
//  */
// export function addDeps(
//   pmt: PackageManagerType,
//   packages: string[],
//   options?: AddDepsOptions
// ): ReturnType<typeof proc.run> {
//   return proc.run(renderAddDeps(pmt, packages, { dev: options?.dev }), options);
// }

/**
 * Add a package to the project.
 */
export function renderAddDeps(
  pmt: PackageManagerType,
  packages: string[],
  options?: { dev?: boolean }
): string {
  const dev = options?.dev ?? false;
  return pmt === "npm"
    ? `npm install ${dev ? "--save-dev " : ""}${packages.join(" ")}`
    : `yarn add ${dev ? "--dev " : ""}${packages.join(" ")}`;
}

//
// Fluent API
//

/**
 * The package manager as a fluent API, all statics partially applied with the
 * package manager type.
 */
// export type PackageManager = {
//   type: PackageManagerType;
//   installDeps: OmitFirstArg<typeof installDeps>;
//   addDeps: OmitFirstArg<typeof addDeps>;
//   runBin: OmitFirstArg<typeof runBin>;
//   runScript: OmitFirstArg<typeof runScript>;
//   renderRunBin: OmitFirstArg<typeof renderRunBin>;
//   renderRunScript: OmitFirstArg<typeof renderRunScript>;
//   renderAddDeps: OmitFirstArg<typeof renderAddDeps>;
// };
